import { cleanEnv, num } from "envalid";

export const validateEnv = ()=>{
    return cleanEnv(process.env, {
        REACT_APP_CAMPAIGN_CANCEL_WINDOW_MINUTES: num({
            desc: "Minutes before scheduled delivery when cancellation is blocked",
            default: 5,
          }),
    })
}
